import { useFormik } from 'formik';
import React, { useRef } from 'react';
import * as yup from 'yup';
import { Input, Modal } from '../ui';

interface UpdateEmailDialogProps {
  isOpen: boolean;
  isUpdatingName?: boolean;
  email: string;
  onClose: () => void;
  onSave: (email: string) => void;
}

export default function UpdateEmailDialog(props: UpdateEmailDialogProps) {
  const cancelButtonRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      email: props.email,
    },
    validationSchema: yup.object().shape({
      email: yup.string().email().required('Email is required'),
    }),
    onSubmit: values => {
      if (props.email !== values.email) {
        props.onSave(values.email);
      }

      props.onClose();
    },
  });

  const handleOnCancel = () => {
    formik.resetForm();
    props.onClose();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={handleOnCancel} initialFocus={cancelButtonRef}>
      <div className="sm:flex sm:items-start">
        <h3 className="text-lg leading-6 font-medium text-gray-900">Update your email</h3>
        <div className="mt-2 max-w-xl text-sm text-gray-500">
          <p>Change the email address you want associated with your account.</p>
        </div>

        <form onSubmit={formik.handleSubmit} className="space-y-6 mt-3">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <div className="mt-1">
              <Input
                type="text"
                name="email"
                id="email"
                required
                autoComplete="given-name"
                error={
                  formik.touched.email && formik.errors.email ? formik.errors.email : undefined
                }
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>

          <div className="space-y-1">
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-xs font-medium rounded-md text-white bg-secondary hover:bg-secondary-dark focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-secondary sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50"
                disabled={
                  !formik.isValid ||
                  (Object.keys(formik.touched).length === 0 &&
                    formik.touched.constructor === Object)
                }
              >
                Save
              </button>
              <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-xs px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-secondary sm:mt-0 sm:w-auto sm:text-sm"
                onClick={handleOnCancel}
                ref={cancelButtonRef}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}
